import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { getOfflineCouponsAction } from '@kfc-global/react-shared/redux/Actions/OfflineCouponActions';

export const CartItem = props => {
  const { key, coupon, timeObj } = props;
  const { minutes, seconds } = timeObj;
  const { PROMO_CART_CODE, SHOW_BARCODE, PROMO_MINUTES, PROMO_SECONDS } = TRANSLATE_MAPPING_KEY;
  return (
    <div key={key} className='promoscart-item'>
      <div className='promoscart-item-code'>
        {coupon?.sbgCoupon ? (
          <a href={coupon?.url} className='promoscart-couponcode url-link'>
            {translateWithI18Next(SHOW_BARCODE)}
          </a>
        ) : (
          <>
            <h5>{translateWithI18Next(PROMO_CART_CODE)}</h5>
            <div className='promoscart-couponcode code'>{coupon?.couponCode}</div>
          </>
        )}
      </div>
      <div className='promoscart-item-text'>
        <h4>{coupon?.name}</h4>
        <div className='promoscart-item-countdown'>
          <span className='cp-minutes'>{minutes}</span>&nbsp;{translateWithI18Next(PROMO_MINUTES)}&nbsp;
          <span className='cp-seconds'>{seconds}</span>&nbsp;{translateWithI18Next(PROMO_SECONDS)}&nbsp;
        </div>
      </div>
    </div>
  );
};
CartItem.propTypes = {
  key: PropTypes.string,
  coupon: PropTypes.object,
  timeObj: PropTypes.object,
};
CartItem.defaultProps = {
  key: '',
  coupon: {},
  timeObj: {},
};

export const CouponCart = props => {
  const { PROMO_CART_HEADER } = TRANSLATE_MAPPING_KEY;
  const { AccordianUpDark, AccordianDownBlack } = IMAGE_PATH;
  const { itemsList } = props;
  const [showCartContent, setCartContent] = useState(false);
  const [timeLeft, setTimeLeft] = useState([]);
  const dispatch = useDispatch();
  const promoCart = useRef(null);
  const toggleCart = () => {
    setCartContent(!showCartContent);
    promoCart.current.classList.toggle('promocart-open');
    return false;
  };

  useEffect(() => {
    const initialTimeLeft = itemsList?.map((coupon, idx) => {
      const parts = coupon?.timestamp?.split(':');
      const mins = parseInt(parts[1]?.trim());
      const secs = parseInt(parts[2]?.trim());
      const startingPoint = (59 - mins) * 60 + (60 - secs);
      return { id: coupon.couponCode, value: startingPoint };
    });
    setTimeLeft(prevTimeLeft => {
      return initialTimeLeft;
    });
    const timer = setInterval(() => {
      setTimeLeft(prevTimeLeft => {
        const nextTimeLeft = prevTimeLeft.map(coupon => {
          const newValue = coupon.value - 1;
          if (newValue <= 0) {
            clearInterval(timer); // countdown finished
            dispatch(getOfflineCouponsAction());
          }
          return { ...coupon, value: newValue };
        });
        return nextTimeLeft;
      });
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [itemsList.length]);

  return (
    <div id='promo-cart' data-testid='promo-cart' className='promocart-open' ref={promoCart}>
      <div className='grid-container'>
        <div className='promoscart-item-header' data-testid='promoscart-item-header' onClick={() => toggleCart()}>
          <h3>
            <span className='promoscart-title'>{translateWithI18Next(PROMO_CART_HEADER)} </span>
            <span className='promoscart-item-count'>{itemsList?.length}</span>
            <img
              src={showCartContent ? AccordianDownBlack : AccordianUpDark}
              className='global-accordian-arrow'
              alt='arrow'
            />
          </h3>
        </div>
        <div className='promoscart-items'>
          {itemsList?.map(coupon => {
            const item = timeLeft.find(item => item.id === coupon?.couponCode);
            const minutes = Math.floor((item?.value % 3600) / 60)
              .toString()
              .padStart(2, '0');
            const seconds = (item?.value % 60).toString().padStart(2, '0');
            return <CartItem key={`cartItem-${coupon?.couponCode}`} coupon={coupon} timeObj={{ minutes, seconds }} />;
          })}
        </div>
      </div>
    </div>
  );
};
CouponCart.propTypes = {
  itemsList: PropTypes.array,
};
CouponCart.defaultProps = {
  itemsList: [],
};
